import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import BigBorderLoopWinsMediator from "ags/mediators/big-border-loop-wins-mediator";
import GatewayResult from "model/gameplay/records/results/gateway-result";
import Components from "slotworks/components/components";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import WaysHighlightComponent from "ags/components/ways-highlight-component";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";
import Contract from "slotworks/utils/contracts/contract";

export default class BigBorderIgnoreWildWindMediator extends BigBorderLoopWinsMediator {

    public start() {

        this.wins = this.getWinsToAnimate();

        // This can happen if there's only a BN win, we don't include those in the win cycle.
        if (this.wins.length <= 0) {
            this.startContract = Contract.getTimeoutContract(500);
            return this.startContract;
        }

        return super.start();
    }

    protected getWinsToAnimate() {
        const wins = super.getWinsToAnimate();

        // "BN" and "BN_WW" wins don't appear in the win cycle.
        const filteredWins = wins.filter((win) => {
            const isNotWild = !(win instanceof LLWildSymbolResult);
            const isNotRetrigger = !(win instanceof ScatterResult);
            const isNotGatewway = !(win instanceof GatewayResult);

            return isNotWild && isNotRetrigger && isNotGatewway;
        });

        return filteredWins;
    }

    protected getCelebrationsForWin(win: any) {

        if (win instanceof GatewayResult) {
            return [
                () => this.showWin(win as any),
                () => Components.celebrateWin.miscWin(win)
            ];
        }

        return super.getCelebrationsForWin(win);
    }

    protected getHighlightForWin(symbols: SymbolComponent[]) {

        const win = this.wins[this.currentWin];

        if (win instanceof GatewayResult) {
            return this.activeBorder = new WaysHighlightComponent(symbols, win);
        }

        return super.getHighlightForWin(symbols);
    }
}
